import {
  type FC
} from 'react';
import {
  SvgIcon,
  type SvgIconProps,
} from '@mui/joy';

export const BellIcon: FC<SvgIconProps> = props => (
  <SvgIcon
    width='24'
    height='24'
    viewBox='0 0 24 24'
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    {...props}>
    <path
      d='M21.052 16.995L19.7695 15.15C19.5944 14.8992 19.5002 14.6009 19.4995 14.295V9C19.4995 7.01088 18.7093 5.10322 17.3028 3.6967C15.8963 2.29018 13.9886 1.5 11.9995 1.5C10.0104 1.5 8.10273 2.29018 6.69621 3.6967C5.28969 5.10322 4.49951 7.01088 4.49951 9V14.295C4.49879 14.6009 4.40458 14.8992 4.22951 15.15L2.94701 16.995C2.75282 17.2102 2.62512 17.477 2.57936 17.7632C2.5336 18.0494 2.57174 18.3427 2.68915 18.6077C2.80657 18.8727 2.99825 19.098 3.241 19.2563C3.48375 19.4147 3.76718 19.4993 4.05701 19.5H8.32451C8.49665 20.3477 8.95656 21.1099 9.62632 21.6573C10.2961 22.2047 11.1345 22.5038 11.9995 22.5038C12.8645 22.5038 13.7029 22.2047 14.3727 21.6573C15.0425 21.1099 15.5024 20.3477 15.6745 19.5H19.942C20.2318 19.4993 20.5153 19.4147 20.758 19.2563C21.0008 19.098 21.1924 18.8727 21.3099 18.6077C21.4273 18.3427 21.4654 18.0494 21.4197 17.7632C21.3739 17.477 21.2462 17.2102 21.052 16.995ZM11.9995 21C11.5353 20.9987 11.0829 20.8538 10.7042 20.5853C10.3256 20.3168 10.0392 19.9377 9.88451 19.5H14.1145C13.9598 19.9377 13.6735 20.3168 13.2948 20.5853C12.9162 20.8538 12.4637 20.9987 11.9995 21ZM4.05701 18C4.09091 17.9685 4.1211 17.9333 4.14701 17.895L5.45951 16.005C5.80964 15.5034 5.99806 14.9067 5.99951 14.295V9C5.99951 7.4087 6.63165 5.88258 7.75687 4.75736C8.88209 3.63214 10.4082 3 11.9995 3C13.5908 3 15.1169 3.63214 16.2422 4.75736C17.3674 5.88258 17.9995 7.4087 17.9995 9V14.295C18.001 14.9067 18.1894 15.5034 18.5395 16.005L19.852 17.895C19.8779 17.9333 19.9081 17.9685 19.942 18H4.05701Z'
      fill='white'
    />
    <path
      d='M3.5 18.5H20.5L19 15.5L18 6L15 2.5H9.5L6 6L5 15.5L3.5 18.5Z'
      fill='white'
    />
  </SvgIcon>
);